/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable no-unused-vars */
/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment-timezone';

import RenderIf from '@components/global/RenderIf';

import { currency, pdfSafeValue } from '@global/helpers';
import { PAGE_SIZE } from './constant';
import Footer from './Footer.web';
import Header from './Header.web';

export default function PdfSkpExternal({ data }) {
  const isVn = (data.is_active_for || []).includes('b2b_vn');
  const Row = ({ label, value }) => (
    <View style={styles.row}>
      <Text style={styles.label}>{label}</Text>
      <Text style={styles.value}>{pdfSafeValue(value)}</Text>
    </View>
  );

  return (
    <Document>
      <Page size={PAGE_SIZE} style={styles.page} wrap>
        <Header isVn={isVn} />

        <View style={styles.container}>
          <Text style={styles.title}>PROMOTION AGREEMENT</Text>

          <View style={styles.headerContainer}>
            <View style={styles.headerRow}>
              <Text style={styles.headerLabel}>SDI :</Text>
              <Text style={styles.headerValue}>
                {pdfSafeValue(data.customer?.sales_team?.name)}
              </Text>
            </View>

            <View>
              <View
                style={[styles.headerRow, { justifyContent: 'space-between' }]}>
                <Text style={styles.headerLabel}>Date :</Text>
                <Text style={styles.headerValue}>
                  {pdfSafeValue(moment(data.created_at).format('D MMMM YYYY'))}
                </Text>
              </View>

              <View
                style={[styles.headerRow, { justifyContent: 'space-between' }]}>
                <Text style={styles.headerLabel}>No Filling :</Text>
                <Text style={styles.headerValue}>
                  {pdfSafeValue(data.reference_code)}
                </Text>
              </View>
            </View>

            <View>
              <View
                style={[styles.headerRow, { justifyContent: 'space-between' }]}>
                <Text style={styles.headerLabel}>SKP Reference :</Text>
                <Text style={styles.headerValue}>
                  {pdfSafeValue(data.skp_internal?.reference_code)}
                </Text>
              </View>

              <View
                style={[styles.headerRow, { justifyContent: 'space-between' }]}>
                <Text style={styles.headerLabel}>Business Type :</Text>
                <Text style={styles.headerValue}>
                  {pdfSafeValue(
                    data.customer?.market_type?.business_type?.code?.toUpperCase(),
                  )}{' '}
                  /{' '}
                  {pdfSafeValue(
                    data.customer?.market_type?.code?.toUpperCase(),
                  )}
                </Text>
              </View>
            </View>
          </View>

          <View style={styles.contentWrapper}>
            <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text>1.</Text>
                <Text style={styles.sectionTitleText}>CUSTOMER</Text>
              </View>
              <View style={styles.subsection}>
                <Row
                  label="Customer Code"
                  value={data.customer?.customer_code}
                />
                <Row label="Customer Name" value={data.customer?.name} />
                <RenderIf condition={data.skp_type == 'subdistributor'}>
                  <Row label="Outlet Code" value={data.outlet?.code} />
                  <Row label="Outlet Name" value={data.outlet?.name} />
                </RenderIf>
                <RenderIf condition={data.skp_type == 'mt'}>
                  <Row
                    label="SKP External Account"
                    value={data.skp_external_account_no}
                  />
                </RenderIf>
                <RenderIf condition={data.skp_type != 'gt'}>
                  <Row label="Invoice Number" value={data.kwitansi_no} />
                </RenderIf>
              </View>
            </View>

            <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text>2.</Text>
                <Text style={[styles.sectionTitleText, { marginRight: 40 }]}>
                  PROMOTION TYPE
                </Text>
                <Text style={{ fontWeight: 400 }}>
                  {pdfSafeValue(data.skp_internal?.coa_tax?.cost_type)}
                </Text>
              </View>
              <View style={styles.subsection}>
                <Row
                  label="Period"
                  value={`${moment(data.from_date).format(
                    'D MMMM YYYY',
                  )} - ${moment(data.to_date).format('D MMMM YYYY')}`}
                />
                <Row
                  label="Claim Type"
                  value={
                    data.claim_type == 'partial'
                      ? 'Partial Claim'
                      : 'Full Claim'
                  }
                />
              </View>
            </View>

            <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text>3.</Text>
                <Text style={styles.sectionTitleText}>BRAND</Text>
              </View>
              <View style={styles.subsection}>
                <View style={styles.table}>
                  <View style={styles.tableHeader} fixed>
                    <Text style={styles.tableHeaderCell}>Brand</Text>
                    <Text style={styles.tableHeaderCell}>Total</Text>
                  </View>

                  {(data.brands || []).map((brand, index) => (
                    <View
                      key={index}
                      style={[
                        styles.tableRow,
                        index % 2 === 0
                          ? styles.tableRowOdd
                          : styles.tableRowEven,
                      ]}
                      wrap={false}>
                      <Text style={styles.tableCell}>{brand.name}</Text>
                      <Text style={styles.tableCell}>{brand.dpp}</Text>
                    </View>
                  ))}
                </View>
              </View>
            </View>

            <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text>4.</Text>
                <Text style={styles.sectionTitleText}>PROMO</Text>
              </View>
              <View style={styles.subsection}>
                <Text>{pdfSafeValue(data.skp_internal?.description)}</Text>
              </View>
            </View>

            <View style={styles.section}>
              <View style={styles.sectionTitle}>
                <Text>5.</Text>
                <Text style={styles.sectionTitleText}>COST</Text>
              </View>
              <View style={styles.subsection}>
                <Row
                  label="Activity Value"
                  value={currency(data.nilai_aktivitas, true)}
                />
                <Row
                  label="Total Cost"
                  value={currency(data.total_biaya, true)}
                />
                <Row label="VAT Value" value={currency(data.ppn, true)} />
                <Row
                  label="Tax ID Number"
                  value={
                    data.customer?.vat_address?.identification_number ||
                    data.customer?.vat
                  }
                />
                <Row label="WHT" value={`${data.wht}%`} />
                <Row
                  label="Gross Up WHT"
                  value={data.grossup_pph ? 'Yes' : 'No'}
                />
                <Row label="WHT Value" value={currency(data.pph, true)} />
                <Row
                  label="Total Nett"
                  value={currency(data.total_nett, true)}
                />
              </View>
            </View>
          </View>
        </View>

        <View style={styles.signatureContainer} wrap={false}>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureTitle}>Customer Sign:</Text>
          </View>

          <View style={styles.signatureBox}>
            <Text style={styles.signatureTitle}>Approved by:</Text>
          </View>
        </View>

        <Footer />
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  page: {
    paddingTop: 15,
    fontSize: 10,
    color: '#000',
    fontFamily: 'Roboto',
    paddingBottom: 20,
  },
  row: { flexDirection: 'row', marginBottom: 3 },
  label: { width: 120, marginRight: 4, fontWeight: 'bold' },
  value: { flexGrow: 1, color: '#000' },

  container: {
    paddingHorizontal: 20,
  },
  title: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 12,
  },

  headerContainer: {
    flexDirection: 'row',
    fontSize: 10,
    marginBottom: 8,
    height: 40,
    width: '100%',
    borderBottom: '2px solid black',
    justifyContent: 'space-between',
  },
  headerRow: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  headerLabel: {
    fontWeight: 'bold',
    marginRight: 10,
  },
  headerValue: {
    color: '#242b38',
    textAlign: 'right',
  },

  contentWrapper: {
    paddingHorizontal: 20,
    marginTop: 10,
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    flexDirection: 'row',
    fontWeight: 'bold',
    marginBottom: 10,
  },
  sectionTitleText: {
    marginLeft: 3,
    textDecoration: 'underline',
  },
  subsection: {
    marginLeft: 12,
  },

  table: {
    width: '60%',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#293b77',
    color: '#fff',
  },
  tableHeaderCell: {
    width: '50%',
    textAlign: 'left',
    fontWeight: 'normal',
    borderRight: '1px solid white',
    paddingVertical: 5,
    paddingLeft: 15,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableRowEven: {
    backgroundColor: '#fff',
  },
  tableRowOdd: {
    backgroundColor: '#f7f7f7',
  },
  tableCell: {
    width: '50%',
    textAlign: 'left',
    paddingVertical: 7,
    paddingLeft: 15,
  },

  signatureContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-around',
  },
  signatureBox: {
    height: 100,
    width: 200,
    border: '2px solid black',
  },
  signatureTitle: {
    textAlign: 'center',
    fontWeight: 'bold',
    borderBottom: '2px solid black',
    paddingVertical: 10,
  },
});
